<script>
import App from '@wielink-application/shared/vue/layouts/app.vue'
export default App;
</script>